import createReducer from '../create-reducer';
import { SHOW_NOTICE, HIDE_NOTICE, LOAD_NEXT_NOTICE } from '../actions/notices';

function showNotice(state, { notice }) {
  return {
    ...state,
    notices: state.notices.concat(notice),
  };
}

function hideNotice(state) {
  return {
    ...state,
    notices: state.notices.slice(1, state.length),
    activeNotice: null,
  };
}

function loadNextNotice(state) {
  return {
    ...state,
    activeNotice: state.notices[0],
  };
}

const handlers = {
  [SHOW_NOTICE]: showNotice,
  [HIDE_NOTICE]: hideNotice,
  [LOAD_NEXT_NOTICE]: loadNextNotice,
};

const DEFAULT_STATE = {
  notices: [],
  activeNotice: null,
};

export default createReducer(DEFAULT_STATE, handlers);
